import { Icon } from "@/components/icon";
import type { NavProps } from "@/components/nav";

export const frontendNavData: NavProps["data"] = [
	// {
	// 	items: [
	// 		{
	// 			title: "sys.nav.workbench",
	// 			path: "/workbench",
	// 			icon: <Icon icon="local:ic-workbench" size="24" />,
	// 		},
	// 	],
	// },
	// 供应链 - 改为一级导航
	{
		items: [
			{
				title: "sys.supplyChain.commodity",
				path: "/commodity",
				icon: <Icon icon="ic:baseline-inventory-2" size="24" />,
			},

			{
				title: "sys.supplyChain.gjj",
				path: "/gjj",
				icon: <Icon icon="ic:baseline-category" size="24" />,
			},
			{
				title: "sys.supplyChain.hpp",
				path: "/hpp",
				icon: <Icon icon="ic:outline-receipt-long" size="24" />,
			},
			{
				title: "sys.supplyChain.order",
				path: "/order",
				icon: <Icon icon="ic:outline-shopping-cart" size="24" />,
			},
			{
				title: "sys.supplyChain.settle",
				path: "/settle",
				icon: <Icon icon="ic:outline-account-balance" size="24" />,
			},
		],
	},
];
